import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Reveal from 'react-reveal/Reveal'
import Link from '../Link'
import FooterWrapper from './Footer.style'

export const query = graphql`
  query FooterDataQuery {
    prismic {
      allFooters(lang: "en-us") {
        edges {
          node {
            name
            body {
              ... on PRISMIC_FooterBodyLink_section {
                type
                primary {
                  title
                }
                fields {
                  url {
                    ...LinkFragment
                  }
                  text
                }
              }
            }
          }
        }
      }
    }
  }
`

const FooterLinks = (footerData) =>
  footerData?.fields.length > 0 ? (
    <ul className='bottom_links' key={footerData.primary.title}>
      {footerData?.fields.map(({ url, text }, index) => (
        <li key={`${url._meta.uid}-${index}`}>
          <Link to={url}>{text[0]?.text}</Link>
        </li>
      ))}
    </ul>
  ) : null

const Footer = () => (
  <StaticQuery
    query={`${query}`}
    render={(data) => {
      const doc = data.prismic?.allFooters?.edges.slice(0, 1).pop()
      if (!doc) return null

      // const brandName = doc.node.brand_name
      // const companyWidget = doc.node.company_widget
      // const linkWidgets = doc.node.body.filter((slice) => slice.type === 'link_widget')
      const footerBody = doc.node?.body
      console.log(footerBody)
      const AdditionalFooterComponent =
        footerBody?.length > 0 ? footerBody.map((footerData) => FooterLinks(footerData)) : null

      return (
        <FooterWrapper className='bg_color'>
          {/** Temporarily disable the footer */}
          {/* <div className='new_footer_top'>
            <div className='container'>
              <div className='row'>
                <Reveal effect='fadeInLeft' duration={500} key={1}>
                  <div className='col-lg-3 col-md-6'>
                    <div className='f_widget company_widget wow fadeInLeft' data-wow-delay='0.2s'>
                      <h3 className='f-title f_600 t_color f_size_18'>{brandName}</h3>
                      <ul className='list-unstyled f_list'>
                        {companyWidget.map((item) => (
                          <li key={item.id}>
                            {item.link ? (
                              <Link to={item.link}>{item.text}</Link>
                            ) : (
                              <span className='coming-soon-link' title='Coming soon'>
                                {item.text}
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Reveal>
                {linkWidgets.map((widget, index) => (
                  <Reveal effect='fadeInLeft' duration={500} key={index}>
                    <div className='col-lg-3 col-md-6'>
                      <div className='f_widget about_widget pl_70 wow fadeInLeft' data-wow-delay='0.4s'>
                        <h3 className='f-title f_600 t_color f_size_18'>{widget.primary.title}</h3>
                        <ul className='list-unstyled f_list'>
                          {widget.fields.map((item) => (
                            <li key={item.id}>
                              {item.link ? (
                                <Link to={item.link}>{item.text}</Link>
                              ) : (
                                <span className='coming-soon-link' title='Coming soon'>
                                  {item.text}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </Reveal>
                ))}
                {FooterData.SocialLinks.map((widget) => (
                  <Reveal effect='fadeInLeft' duration={500} key={widget.id}>
                    <div className='col-lg-3 col-md-6'>
                      <div className='f_widget social-widget pl_70 wow fadeInLeft' data-wow-delay='0.4s'>
                        <h3 className='f-title f_600 t_color f_size_18'>{widget.title}</h3>
                        <div className='f_social_icon'>
                          {widget.menuItems.map((item) => (
                            <Link to='/' key={item.id}>
                              <i className={item.icon} />
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
            <div className='footer_bg'>
              <div className='footer_bg_one' />
              <div className='footer_bg_two' />
            </div>
          </div> */}
          <div className='footer_bottom'>
            <div className='container'>
              <div className='bottom_container'>
                <p className='bottom_copyright'>{`© ${new Date().getFullYear()} Propellant Software, All Rights Reserved.`}</p>
                {AdditionalFooterComponent}
              </div>
            </div>
          </div>
        </FooterWrapper>
      )
    }}
  />
)

export default Footer
